import {
  IconAtom,
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
} from '@assets/images/icon';
import { IconAnalyze, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';

export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: 'Công nghệ' }, { text1: 'Mở cửa bằng di động' }, { text2: 'Mở cửa tự động' }, { text3: 'Mở cửa nhận diện khuôn mặt' }],
    },
    {
      data: [
        { text: 'Ra vào bằng thiết bị di động' },
        { text: 'Thiết bị điều khiển cửa cực kỳ tiện lợi qua app di động' },
        { text: 'Thiết bị mở cửa nhanh chóng mà không cần chạy app' },
        { text: 'Thiết bị tích hợp nhận diện khuôn mặt, NFC… sử dụng đa năng' },
      ],
    },
    {
      data: [{ text: 'Nguồn cấp' }, { text: 'Sử dụng pin (tuổi thọ lên đến 3 năm)' }, { text: 'DC 12V, 24V' }, { text: 'DC 12V, 3A' }],
    },
  ],

  a: [
    { text: 'Băng tần', icon: IconSignal },
    { text: 'Phạm vi hoạt động', icon: IconCoil },
    { text: 'Độ chính xác', icon: IconRuler },
    { text: 'Tìm tài sản', icon: IconSearch },
    { text: 'Đo góc(AoA)', icon: IconRuler },
    { text: 'Theo dõi chính xác<br/>ATDoA', icon: IconAtom },

    { text: 'Nguồn điện', icon: IconPower },
    { text: 'Mức tiêu thụ pin', icon: IconEnergyCircle },
    { text: 'Độ khó lắp đặt', icon: IconTools },
    { text: 'Không gian ứng dụng', icon: IconBuildings },
    { text: 'Môi trường đề xuất', icon: IconBookmark },
    { text: 'Điểm nổi bật', icon: IconPencil },
    { text: 'Kết nối bên ngoài', icon: IconShare },
  ],
  b: [
    { text: '3.1–10.6GHz' },
    { text: '<50m' },
    { text: 'Dưới 10cm' },
    { text: '1' },
    { text: '-' },
    { text: '1' },
    { text: 'PoE' },
    { text: 'Trung bình' },
    { text: '★★★' },
    { text: 'Nhà máy thông minh, cảng biển' },
    { text: 'Nhà máy, kho logistic, xưởng đóng tàu, nhà máy công nghiệp, công trường xây dựng, v.v.' },
    { text: 'Định vị siêu chính xác với độ sai số tính theo đơn vị cm<br/>Hoạt động ổn định ngay cả trong môi trường có nhiều nhiễu' },
    { text: 'Cung cấp API' },
  ],
  c: [
    { text: '2.4GHz' },
    { text: '<30m' },
    { text: '10–30cm' },
    { text: '1' },
    { text: '1' },
    { text: '-' },
    { text: 'PoE' },
    { text: 'Thấp' },
    { text: '★★☆' },
    { text: 'Không gian trong nhà lớn, tòa nhà thông minh' },
    { text: 'Văn phòng, bệnh viện, tự động hóa logistics, cơ sở nghiên cứu' },
    { text: 'Theo dõi vị trí của thẻ Tag xung quanh chỉ với một thiết bị duy nhất' },
    { text: 'Cung cấp API' },
  ],

  d: [
    { text: '2.4GHz' },
    { text: 'Tối đa 100m' },
    { text: 'Trên 10cm' },
    { text: '1' },
    { text: '-' },
    { text: '-' },
    { text: 'PoE' },
    { text: 'Rất thấp' },
    { text: '★☆☆' },
    { text: 'Nhà kho, bệnh viện, không gian quản lý tài sản, v.v.' },
    { text: 'Quản lý tài sản quy mô lớn' },
    { text: 'Chi phí triển khai thấp<br/>Tiêu thụ pin của thẻ rất ít' },
    { text: 'Cung cấp API' },
  ],

  e: [
    { text: '3.1–10.6GHz' },
    { text: '20m' },
    { text: '10–30cm' },
    { text: '-' },
    { text: '-' },
    { text: '1' },
    { text: 'Pin sạc' },
    { text: 'Cao' },
    { text: '★☆☆' },
    { text: 'Không gian demo quy mô nhỏ,<br/>không gian tạm thời' },
    { text: 'Khu vực sử dụng tạm thời, không gian quy mô nhỏ, nơi khó thi công hạ tầng' },
    { text: 'Không cần lắp đặt Anchor<br/>Tính di động cao' },
    { text: 'Không hỗ trợ<br/>(Ứng dụng chuyên dùng)' },
  ],
  spec: [
    {},

    {
      image: schemeUwb,
      link: '/vi/rtls/uwb',
      title: 'TwinTracker UWB',
      desc: 'UWB',
    },

    {
      image: schemeAoa,
      link: '/vi/rtls/aoa',
      title: 'TwinTracker AoA',
      desc: 'BLE + AoA',
    },
    {
      image: schemeBle,
      link: '/vi/rtls/ble',
      title: 'TwinTracker BLE',
      desc: 'BLE',
    },
    {
      image: schemeComfort,
      link: '/vi/rtls/comfort',
      title: 'Comfort Kit',
      desc: 'UWB',
    },
  ],
};
